module.exports = __webpack_public_path__ + "static/media/mobileicon.0c1f1bc8.svg";